import { useParams, useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { uploads } from "../../utils/config";
import Input from '../../components/elements/Input';
import Title2 from '../../components/elements/Title2';
import Button from '../../components/elements/Button';
import Message from '../../components/Message';
import Select from '../../components/elements/Select';
import { motion } from 'framer-motion';
import Zoom from 'react-medium-image-zoom';
import 'react-medium-image-zoom/dist/styles.css';
import {profile, incrementScore, updateCoins, resetMessage} from "../../slices/userSlice";
import { getChallengeByIdNoAnswer } from "../../slices/challengeSlice";
import { sendResponse, getAnswersByChallengeId } from "../../slices/challengeAnswerSlice";
import Swal from 'sweetalert2';

import tips from "../../assets/images/tips.png";
import TipsList from './Tips/TipsList';

const EditChallenge = () => {

  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { challenge, message, error, loading } = useSelector((state) => state.challenge);
  const [challengeAnswers, setChallengeAnswers] = useState("");
  const { user } = useSelector((state) => state.user);
  const [showMessageSuccess, setShowMessageSuccess] = useState(false);
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [difficulty, setDifficulty] = useState('');
  const [openDate, setOpenDate] = useState('');
  const [answer, setAnswer] = useState('');
  const [challengeImage, setChallengeImage] = useState("");
  const [phase, setPhase] = useState("");
  const [block, setBlock] = useState("");
  const [previewImage, setPreviewImage] = useState("");
  const [refreshKey, setRefreshKey] = useState(0);

  useEffect(() => {
    dispatch(getChallengeByIdNoAnswer(id));
  }, [dispatch, id]);

  useEffect(() => {
    profile();
  },[user]);

  useEffect(() => {
    if (user) {
      dispatch(getAnswersByChallengeId({ challengeId: id, userId: user._id }))
        .then((res) => setChallengeAnswers(res.payload || []));
    }
  }, [user, id, dispatch]);

  useEffect(() => {
    if(challenge) {
      setTitle(challenge.title);
      setDescription(challenge.description);
      setDifficulty(challenge.difficulty);
      setOpenDate(challenge.openDate);
      setAnswer(challenge.answer);
      setChallengeImage(challenge.challengeImage);
      setPhase(challenge.phase);
      setBlock(challenge.block);
    }
  }, [challenge]);

  const toggleVisibility = () => {
    if(!error){
      if(message){
        setShowMessageSuccess(true);
      }
    }
  }

  const handleSubmit = async (e) => {
    e.preventDefault();

    const challengeAnswer = {
      challengeId: id,
      userId: user._id,
      answer: answer
    };

    const res = await dispatch(sendResponse(challengeAnswer));
    if(!res.error){
      dispatch(incrementScore({score: res.payload.score}));
      dispatch(updateCoins({coinsEarned: res.payload.coinsEarned}));
      dispatch(getAnswersByChallengeId({ challengeId: id, userId: user._id }))
        .then((res) => setChallengeAnswers(res.payload || []));
      dispatch(resetMessage());

      if(res.payload.correct){
        Swal.fire({
          title: `<h2 class= "mt-2 z-10 font-special text-preto-suave text-center block mb-2 text-2xl font-bold">Parabéns!</h2>`,
          html: `<p class="font-special font-semibold">Você acabou de desvendar este mistério e de recompensa ganhou ${res.payload.score} pontos e ${res.payload.coinsEarned} moedas para comprar novas pistas</p>`,
          icon: 'success',
          showCancelButton: false,
        }).then((result) => {
          if (result.isConfirmed) {
            navigate('/Progress');
          }
        });
      }else{
        Swal.fire({
          title: `<h2 class= "mt-2 z-10 font-special text-preto-suave text-center block mb-2 text-2xl font-bold">Oops!</h2>`,
          html: `<p class="font-special font-semibold">A resposta está incorreta, ${user.nickname}. Tente novamente e não esqueça, a cada erro sua recompensa diminui.</p>`,
          icon: 'error',
        });
      }
    }

  }

  return (
    <>
    <div className="min-h-dvh relative z-10 mt-16">
    <div className="flex justify-center">
      <Title2 tit={"Editar Desafio"} font={"font-roboto"} color={"text-white"}/>
      <div class="grid grid-cols-2 gap-2">
      <motion.div
        className="basis-1/4 bg-verde-oliva border-verde-musgo bg-opacity-85 sm:rounded-lg content-center border-solid shadow-md rounded p-3 m-3 max-w-96 max-h-fit hover:resize"
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        <Zoom>
        <img
          src={`${uploads}/challenge/${challenge.challengeImage}`}
          alt={challenge.title}
          height="auto"
        />
      </Zoom>
      </motion.div>
        <motion.div
        className="basis-1/4 bg-verde-oliva border-verde-musgo bg-opacity-85 sm:rounded-lg content-start justify-start border-solid shadow-md rounded p-3 m-3 min-w-96"
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}>
        <div className="w-full flex justify-center">
          <TipsList />
        </div>
        <form className="mt-10" onSubmit={handleSubmit}>
        <Input
            placeholder="Desvendar"
            onChange={setAnswer}
            label={"Descreva a resposta encontrada"}
            font="font-special text-red"
            value={answer}
          />
          {!loading && <input onClick={toggleVisibility} type="submit" className="font-special font-semibold  transition ease-in-out delay-150 duration-300 hover:-translate-y-1 hover:scale-110 text-white bg-bordo hover:bg-bordo-600 focus:outline-none focus:ring-bege-cl-300 font-medium rounded-full text-sm w-full sm:w-40 px-5 py-2.5 text-center" value="Enviar" />}
          {loading && <Button propertiesButton={{type: "submit", dis: "disabled", desc: "Aguarde..."}}/>}          
        </form>
        <div>
        <div>
          <Title2 tit="Tentativas enviadas" model="def" />
          <ul>
              {challengeAnswers.length > 0 ? (
                  challengeAnswers.map((attempt, index) => (
                    <li key={index}>
                      <span className={(!attempt.isCorrect ? "font-special bg-red text-white font-semibold float-left ml-3 mt-1 p-1 rounded-full" : "font-special bg-green text-white p-1 font-semibold float-left ml-3 mt-1 rounded-full")}>{attempt.responseText} {(attempt.isCorrect ? attempt.score+" pts" : "")} </span>
                      
                    </li>
                  ))
                ) : (
                  <p className="font-special text-white">Nenhuma tentativa registrada.</p>
                )}
            </ul>
          </div>
        </div>
      </motion.div>
      </div>
    </div>
    </div>
    </>
  );
}
//{(attempt.isCorrect ? {attempt.coinsEarned}+" coins" : "")}
export default EditChallenge